module.exports = __webpack_public_path__ + "72d62a210e3fd4ba24a52a90fb5782f7.svg";